<template>
  <edit-modal
    :is-show-dialog="isShowDialog"
    action-label="Сохранить"
    :title="dialogTitle"
    @on-close="onClose"
    @on-action="onAction"
  >
    <v-overlay
      :absolute="true"
      :value="isLoading"
    >
      <v-progress-circular indeterminate size="24"></v-progress-circular>
    </v-overlay>
    <v-form
      ref="form"
      autocomplete="off"
      method="post"
      action=""
    >
      <v-container
        v-model="valid"
        :lazy-validation="true"
      >
        <v-row>
          <v-col
            cols="12"
            md="2"
          >
            <v-text-field
              v-model="editableObject.amount"
              type="number"
              step="0.01"
              min="0.01"
              :rules="[rules.required]"
              :label="$t('warehouse.quantity')"
              required
              autocomplete="off"
              :error-messages="(errors && errors.amount)?errors.amount:null"
              @input="removeError('amount')"
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            md="4"
          >
            <v-select
              v-model="editableObject.actionType"
              :items="actionTypes"
              :label="$t('warehouse.action')"
              single-line
            ></v-select>
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="editableObject.note"
              :counter="200"
              :rules="[rules.max(200)]"
              prepend-icon="mdi-tooltip-text-outline"
              :label="lang($store, 'sap/listings.global.filter.hints.note')"
              autocomplete="off"
              :error-messages="(errors && errors.note)?errors.note:null"
              @input="removeError('note')"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row
          v-if="editableObject.actionType === 'reduce'"
        >
          <v-col
            cols="12"
          >
            <b>{{$t('warehouse.additional_params')}}:</b>
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <cleaner-selector
              :selected-cleaner="selectedCleaner"
              :region="stockItem.region"
              @select="selectCleaner"
              role="all"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </edit-modal>
</template>

<script>
/* utils */
import StockItemProxy from '@/proxies/Stock/StockItemProxy';
import CleanerSelector from '@/components/autocomples/CleanerSelector.vue';
import { deepMerge, cloneObj, prepareValidationMessages } from '@/utils';
/* mixins */
import editModalMixin from '../../mixins/editModalMixin';
import validationMixin from '../../mixins/validationMixin';
/* components */
import EditModal from './EditModal.vue';
import i18n from '@/i18n';


export default {
  name: 'EditModalStockExpense',
  mixins: [editModalMixin, validationMixin],
  components: {
    EditModal,
    CleanerSelector,
  },
  props: {
    stockItem: {
      type: Object,
      default: () => {
      },
    },
    item: {
      type: Object,
      default: () => {
      },
    },
  },
  data() {
    return {
      isLoading: false,
      /* Data */
      initialEditableObject: {
        amount: 0,
        actionType: 'reduce',
        price: 0,
        note: '',
      },
      editableObject: {},
      errors: {},
      selectedCleaner: null,
      actionTypes: [
        {
          value: 'reduce',
          text: i18n.t('warehouse.actionTypes.reduce'),
        },
        {
          value: 'reject',
          text: i18n.t('warehouse.actionTypes.reject'),
        },
        {
          value: 'revoke',
          text: i18n.t('warehouse.actionTypes.revoke'),
        },
      ],
    };
  },
  mounted() {
    this.initEditableObject();
  },
  computed: {
    isCreation() {
      return !(this.item.amount);
    },
    dialogTitle() {
      return '';
    },
  },
  watch: {
    isShowDialog(newVal) {
      if (newVal) {
        this.initEditableObject();
        this.resetValidation();
      }
    },
  },
  methods: {
    initEditableObject() {
      this.editableObject = deepMerge(cloneObj(this.initialEditableObject), this.item);
    },
    resetValidation() {
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    onAction() {
      if (this.$refs.form.validate()) {
        if (this.editableObject.actionType === 'reduce' && !this.selectedCleaner) {
          /* this.$store.dispatch('page/displaySnackbar', {
              text: 'Заполните дополнительные параметры',
              color: 'red darken-3',
              timeout: 6000,
            }); */
          return;
        }

        const data = {
          note: this.editableObject.note,
          amount: (this.editableObject.amount * 100).toFixed(0),
        };

        if (this.editableObject.actionType === 'reduce') {
          data.cleaner = this.selectedCleaner.uuid;
        }
        this.isLoading = true;
        let proxy = new StockItemProxy();
        switch (this.editableObject.actionType) {
          case 'reject':
            proxy = proxy.amountReject(this.stockItem.id, data);
            break;
          case 'revoke':
            proxy = proxy.amountRevoke(this.stockItem.id, data);
            break;
          default:
            proxy = proxy.amountReduce(this.stockItem.id, data);
        }
        proxy.then((response) => {
          console.log(response);
          this.$emit('on-action', {
            item: this.stockItem,
            itemEvent: this.editableObject,
          });
          this.errors = {};
        })
          .catch((error) => {
            this.errors = prepareValidationMessages(error.data.data);
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    selectCleaner(e) {
      this.selectedCleaner = e;
    },
  },
};
</script>

<style lang="sass" scoped>

</style>
